import React from 'react';
import { Box, IconButton, Typography, Tooltip } from '@mui/material';

const CAPTION_SX = {
  mt: 0.5,
  fontSize: 10,
  textTransform: 'uppercase',
};
const BUTTON_SX = {
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 1,
};

/** Use wrapInTooltip when the button needs a tooltip for accessibility. */
function ToolbarButton({
  icon,
  label,
  onClick,
  disabled,
  tooltipTitle,
  wrapInTooltip = true,
}) {
  const button = (
    <IconButton
      onClick={onClick}
      color="primary"
      disabled={disabled}
      sx={BUTTON_SX}>
      {icon}
      <Typography variant="caption" fontWeight="bold" sx={CAPTION_SX}>
        {label}
      </Typography>
    </IconButton>
  );

  if (wrapInTooltip && tooltipTitle) {
    return (
      <Box px={1}>
        <Tooltip title={tooltipTitle} placement="bottom">
          <span>{button}</span>
        </Tooltip>
      </Box>
    );
  }
  return <Box px={1}>{button}</Box>;
}

export default ToolbarButton;
export { CAPTION_SX, BUTTON_SX };
